import { render, staticRenderFns } from "./BoxPager.vue?vue&type=template&id=03130a55&scoped=true&"
import script from "./BoxPager.vue?vue&type=script&lang=js&"
export * from "./BoxPager.vue?vue&type=script&lang=js&"
import style0 from "./BoxPager.vue?vue&type=style&index=0&id=03130a55&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03130a55",
  null
  
)

export default component.exports